import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './MobileThermostatFilter.css';
import { ThermostatActions } from '../../../../store';
import { ConnectedFilterSections } from '../FilterSections';
import { Modal } from '../../../Modal';

export class MobileThermostatFilter extends Component {
  handleClearFilters = () => {
    this.props.clearFilters();
  };

  render() {
    const { onClose, numberOfFilters, filteredThermostatCount } = this.props;
    return (
      <Modal>
        <div className="thermostat-filter-overlay">
          <div className="thermostat-filter-modal">
            <div className="thermostat-filter__header">
              <span className="thermostat-filter__header-item">
                <button
                  className="thermostat-filter__header-item--left thermostat-filter__clear-filters"
                  onClick={() => this.handleClearFilters()}
                >
                  Clear All
                </button>
              </span>
              <span className="thermostat-filter__header-item thermostat-filter__header-title">
                Filters {numberOfFilters > 0 ? `(${numberOfFilters})` : null}
              </span>
              <input
                className="thermostat-filter__header-item thermostat-filter__close-button"
                type="button"
                onClick={() => onClose()}
              />
            </div>
            <div className="thermostat-filter-sections">
              <ConnectedFilterSections />
            </div>
            <div className="thermostat-filter__footer">
              <button onClick={() => onClose()} className="thermostat-filter__main-button">
                Show Thermostats ({filteredThermostatCount})
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

MobileThermostatFilter.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  numberOfFilters: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  filteredThermostatCount: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  return {
    numberOfFilters: state.thermostatReducer.numberOfFilters,
    filteredThermostatCount: state.thermostatReducer.filteredThermostatCount,
  };
}

const mapDispatchToProps = {
  clearFilters: ThermostatActions.clearFilters,
};

const ConnectedMobileThermostatFilter = connect(mapStateToProps, mapDispatchToProps)(MobileThermostatFilter);
export { ConnectedMobileThermostatFilter };
